import { BASE_URL } from '../config';

const BASE = `${BASE_URL}public/inscripcion`;

async function fetchJSON(url, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  try {
    const res = await fetch(url, { ...options, signal: controller.signal });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.message || body.error || `HTTP ${res.status}`);
    }
    return await res.json();
  } finally {
    clearTimeout(timeout);
  }
}

export const api = {
  getProcesses: () => fetchJSON(`${BASE}/admission-process`),

  getDocumentTypes: () => fetchJSON(`${BASE}/document-types`),

  getCosts: (planId) => fetchJSON(`${BASE}/costs/${planId}`),

  searchDni: (docNumber) =>
    fetchJSON(`${BASE}/search-dni`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ document_number: docNumber }),
    }),

  searchUbigeo: (query) => fetchJSON(`${BASE}/ubigeo-search/${encodeURIComponent(query)}`),

  getRequirements: (programId) => fetchJSON(`${BASE}/requeriments/${programId}`),

  register: (formData) =>
    fetchJSON(`${BASE}/register`, { method: 'POST', body: formData }),

  checkDuplicate: (docNumber, detailId) =>
    fetchJSON(`${BASE}/check-postulant/${encodeURIComponent(docNumber)}/${detailId}`).catch(() => null),
};
